import React from "react";
import { Col, Row } from "antd";
import _ from "i18n";
import { connect } from "react-redux";
import FollowUpRow from "./FollowUpRow";



const FollowUp = ({ budgetManagement }) => {
  const { followUp } = budgetManagement;

  return (
    <div className={'follow-up mr-3'}>
      <fieldset className={'follow-up-fieldset'}>
        <legend className={'my-legend'}>{_('FOLLOW_UP')}</legend>
        <div className={'follow-up-content'}>
          <Row className={'follow-up-first-row px-3'}>
            <Col span={4}>{_('REALIZED')}</Col>
            <Col span={2}></Col>
            <Col className={'px-2'} span={6}>{_('REGISTERED')}</Col>
            <Col className={'px-2'} span={6}>{_('price')}</Col>
            <Col span={6}>{_('ADJUSTMENT')}</Col>
          </Row>
          {followUp.map(({ realizedHTVA, registrantsCount, totalHTVA, followUpPricePerUnit }, index) => (
            <React.Fragment>
              <FollowUpRow
                realizedHTVA={realizedHTVA}
                registrantsCount={registrantsCount}
                totalHTVA={totalHTVA}
                followUpPricePerUnit={followUpPricePerUnit}
                style={
                  index % 2 === 0
                    ? { backgroundColor: "#FAFBFB" }
                    : { backgroundColor: "#F8F9FA" }
                }
                key={index}
                index={index}
              >
              </FollowUpRow>
            </React.Fragment>
          ))}
        </div>
      </fieldset>
    </div>

  );

};

const mapStateToProps = state => ({
  budgetManagement: state.budgetManagement,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FollowUp);



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/BudgetManagement/FollowUp.js